import React, { useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Select from 'react-select';
import { DatePicker } from 'antd';
import { Modal } from 'react-bootstrap';
import moment from 'moment';

const productSchema = Yup.object().shape({
  product: Yup.object().required('Product is required'),
  unit: Yup.string(),
  quantity: Yup.number()
    .typeError('Quantity must be a number')
    .required('Quantity is required')
    .positive('Quantity must be positive'),
  purchaseRate: Yup.number()
    .typeError('Rate must be a number')
    .required('Rate is required')
    .positive('Rate must be positive'),
  note: Yup.string(),
  supplier: Yup.object().required('Supplier is required'),
});

const EditPurchasesOrder = ({ 
  purchasesOrder, 
  productlist, 
  suppliersList, 
  onUpdate, 
  onCancel,
  isUpdating,
  isLoading 
}) => {
  console.log('EditPurchasesOrder props:',   purchasesOrder
  // productlist
  // suppliersList, 
  // onUpdate, 
  // onCancel,
  // isUpdating,
  // isLoading
 );
  // Prepare product options
  
  const productOptions = productlist?.map(product => ({
    value: product._id,
    label: product.productName,
    unit: product.unit?.unitName || product.unit, // Handle both object and string units
    purchaseRate: product.purchaseRate
  })) || [];
    const currentProduct = productOptions.find(p => 
    p.value === (purchasesOrder?.product?._id || purchasesOrder?.product)
  ) || null;
  const supplierOptions = suppliersList?.map(supplier => ({
    value: supplier._id,
    label: supplier.supplierName
  })) || [];
  const currentSupplier = supplierOptions.find(c => 
    c.value === (purchasesOrder?.supplier?._id || purchasesOrder?.supplier)
  ) || null;
useEffect(() => {
  if (purchasesOrder && productOptions.length && supplierOptions.length) {
    formik.setValues({
      purchaseDate: purchasesOrder?.purchaseDate ? moment(purchasesOrder.purchaseDate) : moment(),
      product: productOptions.find(p => p.value === (purchasesOrder?.product?._id || purchasesOrder?.product)),
      supplier: supplierOptions.find(s => s.value === (purchasesOrder?.supplier?._id || purchasesOrder?.supplier)),
      quantity: purchasesOrder?.quantity || 0,
      unit: purchasesOrder?.unit || '',
      purchaseRate: purchasesOrder?.purchaseRate || purchasesOrder?.rate || '',
      note: purchasesOrder?.note || ''
    });
  }
}, []); // Add proper dependencies
  // Prepare supplier options


  // Find current product and supplier


  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      purchaseDate: purchasesOrder?.purchaseDate ? moment(purchasesOrder.purchaseDate) : moment(),
      product: currentProduct,
      supplier: currentSupplier,
      quantity: purchasesOrder?.quantity || 0,
      unit: purchasesOrder?.unit || (currentProduct?.unit || ''),
      purchaseRate: purchasesOrder?.purchaseRate || purchasesOrder?.rate || (currentProduct?.purchaseRate || ''),
      note: purchasesOrder?.note || ''
    },
    validationSchema: productSchema,
    onSubmit: (values) => {
      const updateData = {
        _id: purchasesOrder._id,
        productId: values.product.value,
        supplierId: values.supplier.value,
        quantity: values.quantity,
        unit: values.unit,
        purchaseRate: values.purchaseRate,
        note: values.note,
        purchaseDate: values.purchaseDate.toISOString()
      };
      onUpdate(updateData);
    }
  });

  const handleProductSelect = (option) => {
    formik.setFieldValue('product', option);
    if (option) {
      formik.setFieldValue('unit', option.unit || '');
      formik.setFieldValue('purchaseRate', option.purchaseRate || '');
    }
  };

  const getError = (field) => {
    return formik.touched[field] && formik.errors[field];
  };

  return (
    <Modal show={true} onHide={onCancel} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit Purchase Order</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isLoading ? (
          <div className="text-center py-4">Loading purchase order data...</div>
        ) : (
          <form onSubmit={formik.handleSubmit}>
            <div className="row">
              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="input-blocks">
                  <label>Purchase Date</label>
                  <DatePicker
                    value={formik.values.purchaseDate}
                    onChange={(date) => formik.setFieldValue('purchaseDate', date)}
                    format="DD-MM-YYYY"
                    className="form-control"
                  />
                  {getError('purchaseDate') && (
                    <div className="text-danger">{getError('purchaseDate')}</div>
                  )}
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="input-blocks">
                  <label>Supplier Name</label>
                  <Select
                    name="supplier"
                    options={supplierOptions}
                    classNamePrefix="react-select"
                    placeholder="Choose"
                    value={formik.values.supplier}
                    onChange={(option) => formik.setFieldValue('supplier', option)}
                    onBlur={() => formik.setFieldTouched('supplier', true)}
                  />
                  {getError('supplier') && (
                    <div className="text-danger">{getError('supplier')}</div>
                  )}
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="input-blocks">
                  <label>Product Name</label>
                  <Select
                    name="product"
                    options={productOptions}
                    classNamePrefix="react-select"
                    placeholder="Choose"
                    value={formik.values.product}
                    onChange={handleProductSelect}
                    onBlur={() => formik.setFieldTouched('product', true)}
                  />
                  {getError('product') && (
                    <div className="text-danger">{getError('product')}</div>
                  )}
                </div>
              </div>

              <div className="col-lg-2 col-md-6 col-sm-12">
                <div className="input-blocks">
                  <label>Quantity</label>
                  <input
                    type="number"
                    className="form-control"
                    name="quantity"
                    value={formik.values.quantity}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {getError('quantity') && (
                    <div className="text-danger">{getError('quantity')}</div>
                  )}
                </div>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-lg-2 col-md-6 col-sm-12">
                <div className="input-blocks">
                  <label>Unit</label>
                  <input
                    type="text"
                    className="form-control"
                    name="unit"
                    value={formik.values.unit}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    readOnly
                  />
                  {getError('unit') && (
                    <div className="text-danger">{getError('unit')}</div>
                  )}
                </div>
              </div>

              <div className="col-lg-2 col-md-6 col-sm-12">
                <div className="input-blocks">
                  <label>Purchase Rate</label>
                  <input
                    type="number"
                    className="form-control"
                    name="purchaseRate"
                    value={formik.values.purchaseRate}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {getError('purchaseRate') && (
                    <div className="text-danger">{getError('purchaseRate')}</div>
                  )}
                </div>
              </div>

              <div className="col-lg-2 col-md-6 col-sm-12">
                <div className="input-blocks">
                  <label>Note</label>
                  <input
                    type="text"
                    className="form-control"
                    name="note"
                    value={formik.values.note}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {getError('note') && (
                    <div className="text-danger">{getError('note')}</div>
                  )}
                </div>
              </div>

              <div className="col-lg-2 col-md-6 col-sm-12 d-flex align-items-end">
                  <div className="input-blocks w-100 d-flex justify-content-end ms-5">
                  <button 
                    type="submit" 
                    className="btn btn-success me-2"
                    disabled={isUpdating}
                  >
                    {isUpdating ? 'Updating...' : 'Update'}
                  </button>
                  <button 
                    type="button" 
                    className="btn btn-secondary"
                    onClick={onCancel}
                    disabled={isUpdating}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </form>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default EditPurchasesOrder;